import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result } from "../../../../interfaces";
import { Find } from "../../../entities";
import { Adapter } from "../../../../shared/adapter";
import { CommonsAdapter } from "../../../../adapter/commons-adapter";
import { EntityAdapter } from "../../../../adapter/entity-adapter";

export const FETCH_DATA_ENTITIES_REQUEST = "FETCH_DATA_ENTITIES_REQUEST";
export const FETCH_DATA_ENTITIES_SUCCESS = "FETCH_DATA_ENTITIES_SUCCESS";
export const FETCH_DATA_ENTITIES_FAILURE = "FETCH_DATA_ENTITIES_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDataMyEntityRequest = () => {
  return {
    type: FETCH_DATA_ENTITIES_REQUEST,
  };
};

const fetchDataEntitiesSuccess = (data: any): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DATA_ENTITIES_SUCCESS,
    payload: data,
  };
};

const fetchDataMyEntityFailure = (error: any) => {
  return {
    type: FETCH_DATA_ENTITIES_FAILURE,
    payload: error,
  };
};

export const getMeEntities = (page: number, pageSize: number, query: Query) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDataMyEntityRequest());
    try {
      const response = await Find("entities", query, page, pageSize);
      dispatch(
        fetchDataEntitiesSuccess({
          meta: response.meta,
          values: Adapter.from(response.data).to((value) =>
            new EntityAdapter(value).adapt()
          ),
        })
      );
    } catch (error: any) {
      dispatch(fetchDataMyEntityFailure(error.message));
    }
  };
};
